import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterTag_template} from "./filterTag_template";
import {filterTagType_template} from "./filterTagType_template";
import {filterAutocomplete_template} from "./filterAutocomplete_template";
import { infoButton_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;

export class tagRatingsList_template extends vnTemplate {

    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;
    protected tagFilter: filterTag_template;
    protected tagTypeFilter: filterTagType_template;
    public reviewerFilter: filterAutocomplete_template;
    protected reviewerTypeFilter: multipleSelector_template;
    protected brandFilter: multipleSelector_template;
    protected ratingsEditTooltip : infoButton_template;
    protected editRatingObject : any;


    protected getTemplateHtml(): string {

        return /* html */`

            <div class="sub-header w-justify">
                <div class="w-left">
                    <div>
                        ${ this.tagFilter.getHtmlBuild() }
                    </div>
                    <div>
                        ${ this.tagTypeFilter.getHtmlBuild() }
                    </div>
                    <div>
                        ${ this.reviewerFilter.getHtmlBuild() }
                    </div>
                    <div>
                        ${ this.reviewerTypeFilter.getHtmlBuild() }
                    </div>
                    <div>
                        ${ this.brandFilter.getHtmlBuild() }
                    </div>
                </div>
            </div>

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-tags"></div>
                    <div id="selected-tag-types"></div>
                    <div id="selected-reviewer-type"></div>
                    <div id="selected-brand"></div>
                </div>
            </div>

            <div class="list-header w-justify" >

                <div class="w-left"></div>

                <div class="w-center"></div>

                <div class="w-right">
                    <div id="pagination" class="w-pagination" data-bind="template: { name: 'pagination-template', data: pagination }">
                        <div class="pagination">
                            <input data-bind="value: pageNumber" type="hidden" value="1">
                            <span><a data-bind="event: { click: onClickPageFirst }" class="hidden prev">first</a></span>
                            <ul data-bind="foreach: pages">
                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page active">1</a></li>

                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">2</a></li>

                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">3</a></li>
                            </ul>
                            <span><a data-bind="event: { click: onClickPageLast }" class="hidden next">last</a></span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ${this.resultInfos.getHtmlBuild()}
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'brandName') }, css: { 'list-sort-desc': orderByAndDirection()=='brandName_DESC', 'list-sort-asc': orderByAndDirection()=='brandName_ASC' }">Brand</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'reviewerName') }, css: { 'list-sort-desc': orderByAndDirection()=='reviewerName_DESC', 'list-sort-asc': orderByAndDirection()=='reviewerName_ASC' }">Reviewer</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'reviewerType') }, css: { 'list-sort-desc': orderByAndDirection()=='reviewerType_DESC', 'list-sort-asc': orderByAndDirection()=='reviewerType_ASC' }">Reviewer Type</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'tagName') }, css: { 'list-sort-desc': orderByAndDirection()=='tagName_DESC', 'list-sort-asc': orderByAndDirection()=='tagName_ASC' }">Tag</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'rating') }, css: { 'list-sort-desc': orderByAndDirection()=='rating_DESC', 'list-sort-asc': orderByAndDirection()=='rating_ASC' }">Rating</span></th>
                            <!--<th class="align-right"><span>DEBUG FOR SAVE REMOVE</span></th>-->
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: {data: tagRatings, as: 'tagRating'}">
                        <tr class="cursor" >
                            <!-- removed the click event for now, until we have the view in place -->
                            <td class="brands"><a><span class="dark" data-bind="css: tagRating.brandIconImage"></span></a></td>
                            <td><!-- data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }">--><span data-bind="text: tagRating.reviewerName == null ? tagRating.reviewerEmail : tagRating.reviewerName"></span><!--</a>--></td>
                            <td><!-- data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }">--><span data-bind="css: { 'icon site-logo': tagRating.reviewerType == '1', 'icon i-users': tagRating.reviewerType != '1'}"></span><!--</a>--></td>
                            <td><!-- data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }">--><span data-bind="text: (tagRating.tagType ? tagRating.tagName.concat(' (', tagRating.tagType, ')') : tagRating.tagName)"></span><!--</a>--></td>
                            <td><!-- data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }">--><span data-bind="text: tagRating.rating"></span><!--</a>--></td>
                            <!--<td class="align-right"><button type="button" data-bind="event: { click: $parent.onClickShowPopUp }, clickBubble: false" class="btn border only-icon icon i-edit"></button></td>-->
                        </tr>
                    </tbody>
                </table>
            </div>

            <div id="edit-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content comment-edit">

                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Edit Comment</h3>
                            <button type="button"  data-bind="event: { click: onClickHidePopUp }" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group comment-edit" data-bind="if: ratingToEdit() !== null">
                                <div class="form-label">Rating: </div>
                                <p class="form-text" data-bind="text: ratingToEdit().rating"></p>
                                <div class="form-label">Comment: </div>
                                <p class="form-text" data-bind="text: ratingToEdit().commentText"></p>
                                <div class="form-label">Brand:</div>
                                    <div class="form-comment-brand">
                                    <select data-bind="value: idEditBrand, selected: ratingToEdit().brand, options: brandOptions, optionsText: 'name', optionsValue: 'id'"></select>
                                    <div class="w-tooltips-adv pos-top mini"> ${this.ratingsEditTooltip.getHtmlBuild()} </div>
                                </div>
                            </div>
                         </div>

                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHidePopUp }" class="btn">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickSave }" class="btn highlight">Save</button>
                        </div>
                    </div>

                </div>
            </div>
          `;
    }

    protected initPartial(): void {

        this.tagFilter = new filterTag_template("tagFilter", this.getTemplateViewModel(), this.caller);
        this.tagFilter.asMultipleSelectionMode();

        this.tagTypeFilter = new filterTagType_template("tagTypeFilter", this.getTemplateViewModel(), this.caller);
        this.tagTypeFilter.asMultipleSelectionMode();

        this.reviewerFilter = new filterAutocomplete_template("reviewerFilter", this.getTemplateViewModel(), this.caller);
        this.reviewerFilter.setPlaceholderAndLabel( 'Reviewer' );
        this.reviewerFilter.setOptionType("Reviewer");
        this.reviewerFilter.setAddNewOptionEnabled(false);

        this.reviewerTypeFilter = new multipleSelector_template("reviewerTypeFilter", this.getTemplateViewModel(), this.caller);
        this.reviewerTypeFilter.setLabel("Reviewer Type");
        this.reviewerTypeFilter.setFilterContainerClass('margin-neg');
        this.reviewerTypeFilter.setTagContainerId('selected-reviewer-type');
        this.reviewerTypeFilter.setTagContainerCaption('Selected Reviewer:');

        this.brandFilter = new multipleSelector_template("brandFilter", this.getTemplateViewModel(), this.caller);
        this.brandFilter.setLabel( 'Brand' );
        this.brandFilter.setFilterContainerClass('margin-neg');
        this.brandFilter.setTagContainerId('selected-brand');
        this.brandFilter.setTagContainerCaption('Selected Brand:');

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

        this.ratingsEditTooltip = new infoButton_template('ratingsEditTooltip', this.getTemplateViewModel(), this.caller);
        this.ratingsEditTooltip.setTitle('User Tag Rating');
        let ratingsTooltipText = `<p>Review and set the brand of the User Rating</p>`;
        this.ratingsEditTooltip.setContent(ratingsTooltipText);
    }

    protected getTemplateName(): string {
        return "tagRatingsList_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    public setFilterSelectedItems(objFilter, urlParams){
        let splitString = [];

        // Multi select filters.
        if(Array.isArray(urlParams)){
            urlParams = urlParams.toString();
        }
        if(urlParams || urlParams === 0) {
            if(typeof urlParams == "string"){
                splitString = urlParams.split(",");
            }else{
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {

                if(!isNaN(Number(id))){
                    id = Number(id);
                }else{
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        }else{
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let self = this;
        return {
            orderBy: ko.observable("dateUpdated"),
            orderByDirection: ko.observable("DESC"),
            tagRatings: ko.observableArray([]),
            orderByAndDirection: ko.observable("dateUpdated_DESC"),
            isAddButtonShown: ko.observable(true),
            brandId: ko.observable(undefined),
            ratingToEdit: ko.observable(null),
            idEditBrand: ko.observable(null),
            brandOptions: ko.observableArray([]),
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            onClickView: (value) =>  {
                self.onClickView(value);
            },
            onClickShowPopUp: (data, event) =>  {
                self.onClickShowPopUp(data)
            },
            onClickHidePopUp : (data, event) =>{
                self.onClickHidePopUp()
            },
            onClickSave : (data, event) =>{
                self.onClickSave()
            },
        };
    }

    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {

        let debug = {
            orderBy: this.getTemplateViewModel().orderBy
            , orderByDirection: this.getTemplateViewModel().orderByDirection
            , orderByAndDirection: this.getTemplateViewModel().orderByAndDirection
            , pagination: this.getTemplateViewModel().pagination
            , filters      : {
                tags: this.tagFilter.getTagsForRequest(),
                tagTypeName: this.getTemplateViewModel().tagTypeFilter.tagType,
                tagTypes: this.tagTypeFilter.getTagsForRequest(),
                reviewers: this.reviewerFilter.getViewModelForRequest(),
                reviewerTypes: this.getTemplateViewModel().reviewerTypeFilter.selectedItems,
                brand: this.getTemplateViewModel().brandFilter.selectedItems,
            },
        }
        return debug;
    }

    public setViewModelFromRequest(urlParams) {
        const {tags, tagTypes, reviewers, reviewerTypes, brand} = urlParams


        if (urlParams != null) {
            const newUrlParams = {
                tags: tags,
                tagTypes: tagTypes,
                reviewers: reviewers,
                reviewerTypes: reviewerTypes,
                brand: brand,
            }

            if (newUrlParams.tags) {
                this.tagFilter.setSelectedTagsFromRequestParams(newUrlParams.tags);
            } else {
                this.tagFilter.resetTagContainer();
            }

            this.tagTypeFilter.setSelectedItems(newUrlParams.tagTypes);

            if (newUrlParams.reviewers && typeof newUrlParams.reviewers !== 'object' || Object.keys(newUrlParams.reviewers).length > 0) {
                this.setReviewerFilter(newUrlParams.reviewers);
            }

            this.setFilterSelectedItems(this.reviewerTypeFilter, newUrlParams.reviewerTypes);
            this.setFilterSelectedItems(this.brandFilter, newUrlParams.brand);
        }
    }

    public getViewModelForSave(){

        return {
            ratingToEdit: this.getTemplateViewModel().ratingToEdit,
            idEditBrand: this.getTemplateViewModel().idEditBrand,
        }
    }

    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.ratingsListReorder();
    }

    public setTagRatings(tagRatingss) {

        this.getTemplateViewModel().tagRatings(tagRatingss);
    }

    protected setTagFilter(tags) {

        this.getTemplateViewModel().tagFilter.tags(tags);
    }

    protected setTagTypeFilter(tagTypes) {

        this.getTemplateViewModel().tagTypeFilter.tagTypes(tagTypes);
    }

    protected setReviewerFilter(reviewers) {

        if (reviewers && typeof reviewers !== 'object' || Object.keys(reviewers).length > 0) {
            this.reviewerFilter.setOptions(reviewers);
        }
    }

    protected setReviewerTypeFilter(reviewerTypes) {

        this.getTemplateViewModel().reviewerTypeFilter.users(reviewerTypes);
    }
    public setReviewerTypeFilterItems(items) {
        this.reviewerTypeFilter.setItems(items);
    }

    protected setBrandFilter(brand) {

        this.getTemplateViewModel().brandFilter.users(brand);
    }

    public setBrandFilterItems(items) {
        this.brandFilter.setItems(items);
        this.getTemplateViewModel().brandOptions(items);
    }

    public setAddButtonShown(isAddButtonShown: boolean) {

        this.getTemplateViewModel().isAddButtonShown(isAddButtonShown);
    }

    public setBrandId(brandId?: number): void {

        this.getTemplateViewModel().brandId(brandId);
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public onClickView(value) {
        return; //The view is not yet implemented and we just have a edit.
    }

    public onClickShowPopUp(data) {
        this.editRatingObject = data;

        this.getTemplateViewModel().ratingToEdit(this.editRatingObject);
        this.getTemplateViewModel().idEditBrand(this.editRatingObject.idBrand);
        this.toggleEditDialogVisibility();
    }

    public onClickHidePopUp(){

        this.getTemplateViewModel().ratingToEdit(null);
        this.getTemplateViewModel().idEditBrand(null);

        this.toggleEditDialogVisibility();
    }

    public onClickSave(){

        this.caller.editRating();
    }

    public toggleEditDialogVisibility() {

        document.getElementById('edit-dialog').classList.toggle('is-visible');
    }

    public getBrandId(): number {

        return this.caller.getBrandId();
    }

    public isBrand(): boolean {

        return this.caller.isBrand();
    }

    public sendTagFilterUpdates(tags) {
        // if the default filter's tag search is filled in, go with that one.
        if (this.tagFilter.getTemplateViewModel().tag() !== '') {
            this.setTagFilter(tags);
        } else {
            this.setTagFilter(tags);
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/tagRatingsList_template.ts